import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const PRODUCTS = [
  { key: "mutual_fund", label: "Mutual Fund" },
  { key: "share_bond", label: "Share & Bond" },
  { key: "fixed_deposit", label: "Fixed Deposit" },
  { key: "other_assets", label: "Other Assets" },
];

const SUMMARY_COLS = ["Equity", "Hybrid", "Debt & Others", "Total"];
const SUMMARY_ROWS = [
  "Opening Balance",
  "Purchase",
  "Switch In",
  "Switch Out",
  "Div. PayOut",
  "Redemption",
  "Net Addition",
  "Closing Balance",
];
const SUMMARY_FOOTER = ["Net Gain", "XIRR(%)"];

const CASHFLOW_COLS = ["Applicant", "Schemes", "Folio", "Date", "Transaction Type", "Amount"];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

function SummaryTable({ title, onExportXls }) {
  return (
    <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
      <div className="card-header d-flex justify-content-between align-items-center py-2 px-3" style={{ background: TEAL, color: "#fff", fontWeight: "600" }}>
        {title}
        <button type="button" className="btn btn-sm p-1 text-white border-0 bg-transparent" onClick={onExportXls} title="Export Excel">
          <i className="fa fa-file-excel" style={{ fontSize: "1.1rem" }} />
        </button>
      </div>
      <div className="table-responsive">
        <table className="table table-sm mb-0">
          <thead>
            <tr style={{ background: TEAL, color: "#fff" }}>
              <th style={{ padding: "8px 12px", fontWeight: "600", fontSize: "12px" }} />
              {SUMMARY_COLS.map((c) => (
                <th key={c} style={{ padding: "8px 12px", fontWeight: "600", fontSize: "12px", textAlign: "right" }}>
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {SUMMARY_ROWS.map((row) => (
              <tr key={row}>
                <td style={{ padding: "8px 12px", fontSize: "13px", color: "#334155" }}>{row}</td>
                {SUMMARY_COLS.map((_, i) => (
                  <td key={i} style={{ padding: "8px 12px", fontSize: "13px", textAlign: "right", color: "#64748b" }}>
                    0
                  </td>
                ))}
              </tr>
            ))}
            <tr style={{ borderTop: "2px solid #e2e8f0" }}>
              <td colSpan={5} />
            </tr>
            {SUMMARY_FOOTER.map((row) => (
              <tr key={row}>
                <td style={{ padding: "8px 12px", fontSize: "13px", color: "#334155" }}>{row}</td>
                {SUMMARY_COLS.map((_, i) => (
                  <td key={i} style={{ padding: "8px 12px", fontSize: "13px", textAlign: "right", color: "#64748b" }}>
                    0
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function PortfolioSnapshot() {
  const [investor, setInvestor] = useState("all_selected");
  const [products, setProducts] = useState(() =>
    PRODUCTS.reduce((acc, p) => ({ ...acc, [p.key]: true }), {})
  );
  const [dateFrom, setDateFrom] = useState("2025-04-01");
  const [dateTo, setDateTo] = useState("2026-02-11");
  const [cashflowView, setCashflowView] = useState("since_inception");
  const [applying, setApplying] = useState(false);

  const toggleProduct = (key) => {
    setProducts((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: fetch snapshot data
  };

  const handleApplyCashflow = () => {
    // TODO: apply cashflow view
  };

  const handleExportSummaryXls = (which) => () => {
    // TODO: export Given Period or Since Inception
  };

  const handleExportCashflowXls = () => {
    // TODO: export cashflow
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Portfolio Snapshot</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/portfolio-snapshot">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Portfolio Snapshot</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Title + Filters */}
        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          <div className="d-flex align-items-center gap-2 mb-3">
            <span className="fw-semibold" style={{ color: "#334155", fontSize: "15px" }}>
              View Money Inflow and Outflow during a given period along with returns.
            </span>
            <i className="fa fa-info-circle text-muted" style={{ fontSize: "1rem" }} aria-hidden />
          </div>
          <div className="row g-3 align-items-end">
            <div className="col-md-2">
              <label className="form-label small text-muted mb-1">Investor:</label>
              <select
                className="form-select form-select-sm"
                value={investor}
                onChange={(e) => setInvestor(e.target.value)}
                style={inputBorderStyle}
              >
                <option value="all_selected">All Selected</option>
                <option value="primary">Primary</option>
              </select>
            </div>
            <div className="col-md-5">
              <label className="form-label small text-muted mb-1">Choose Products:</label>
              <div className="d-flex flex-wrap gap-3">
                {PRODUCTS.map((p) => (
                  <label key={p.key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={products[p.key]}
                      onChange={() => toggleProduct(p.key)}
                      style={{ accentColor: TEAL, width: 16, height: 16 }}
                    />
                    <span style={{ fontSize: "14px", color: "#475569" }}>{p.label}</span>
                  </label>
                ))}
              </div>
            </div>
            <div className="col-md-4">
              <label className="form-label small text-muted mb-1">Date Range:</label>
              <div className="d-flex align-items-center gap-2">
                <div className="input-group input-group-sm">
             
                  <input
                    type="date"
                    className="form-control"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                    style={inputBorderStyle}
                  />
                </div>
                <span className="text-muted">-</span>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={{ ...inputBorderStyle }}
                />
              </div>
            </div>
            <div className="col-md-1">
              <button
                type="button"
                className="btn btn-primary"
             
                onClick={handleApply}
                disabled={applying}
              >
                {applying ? "…" : "Apply"}
              </button>
            </div>
          </div>
        </div>

        {/* Summary tables - Given Period & Since Inception */}
        <div className="row g-4 mb-4">
          <div className="col-md-6">
            <SummaryTable title="Given Period" onExportXls={handleExportSummaryXls("given_period")} />
          </div>
          <div className="col-md-6">
            <SummaryTable title="Since Inception" onExportXls={handleExportSummaryXls("since_inception")} />
          </div>
        </div>

        {/* Cashflow section */}
        <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-2 py-2 px-3" style={{ background: TEAL, color: "#fff", fontWeight: "600" }}>
            <span>View Cashflow</span>
            <div className="d-flex align-items-center gap-3">
              <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                <input
                  type="radio"
                  name="cashflowView"
                  value="given_period"
                  checked={cashflowView === "given_period"}
                  onChange={() => setCashflowView("given_period")}
                  style={{ accentColor: "#fff" }}
                />
                Given Period
              </label>
              <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                <input
                  type="radio"
                  name="cashflowView"
                  value="since_inception"
                  checked={cashflowView === "since_inception"}
                  onChange={() => setCashflowView("since_inception")}
                  style={{ accentColor: "#fff" }}
                />
                Since Inception
              </label>
              <button
                type="button"
                className="btn btn-sm text-white border border-white"
                style={{ borderRadius: "6px", fontWeight: "600" }}
                onClick={handleApplyCashflow}
              >
                Apply
              </button>
              <button type="button" className="btn btn-sm p-1 text-white border-0 bg-transparent" onClick={handleExportCashflowXls} title="Export Excel">
                <i className="fa fa-file-excel" style={{ fontSize: "1.1rem" }} />
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead style={{ background: TEAL, color: "#fff" }}>
                <tr>
                  {CASHFLOW_COLS.map((c) => (
                    <th key={c} style={{ padding: "10px 12px", fontWeight: "600", fontSize: "13px" }}>
                      {c}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: "10px 12px" }}>Opening Balance</td>
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }}>0</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }}>01-01-1970</td>
                  <td style={{ padding: "10px 12px" }} />
                  <td style={{ padding: "10px 12px" }} />
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className="d-flex justify-content-between align-items-center px-3 py-2"
            style={{ background: TEAL, color: "#fff", fontWeight: "600", fontSize: "14px" }}
          >
            <span>Current Value as on {dateTo ? new Date(dateTo + "T00:00:00").toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, "-") : "11-02-2026"} is 0</span>
            <span>XIRR(%) : 0</span>
          </div>
        </div>
      </div>
    </>
  );
}
